<script setup>
import { computed, inject, onMounted, ref } from 'vue';
import { __, requestPaymentURL, requestPaymentUpdate } from '@/utils'
import Notice from '@components/notice/notice.vue';
import FraudModal from "@components/FraudModal.vue";
import DebtNoticeModal from './debt-notice-modal.vue';
import DebtPaymentModal from './debt-payment-modal.vue';
import { useRoute, useRouter } from 'vue-router';
import DebtError from './debt-error.vue';
import DebtSuccess from './debt-success.vue';

const { details } = inject('account');
const route = useRoute();
const router = useRouter();


const showDebt = ref(false);
const showfraudAccountPopup = ref(false);
const apiPayment = ref('');
const loadingUpdate = ref(false);
const openPayment = ref(false);
const successModal = ref(false);
const errorModal = ref(false);

const fetchPaymentURL = async () => {
  try {
	loadingUpdate.value = true;
    const response = await requestPaymentURL('account/#');
	loadingUpdate.value = false;

    if(response?.data?.error && response?.data?.errorMessage === "fraudulent-account"){
		showfraudAccountPopup.value = true;
		openPayment.value = false;
		return false;
    } else {
		apiPayment.value = response;
		return true;
	}
  } catch (error) {
    console.error('Error fetching payment URL:', error);
	openPayment.value = false;
	return false
  }
};

const handlePayment = async () => {
	openPayment.value = true;
	const hasPaymentUrl = await fetchPaymentURL();
	if(!hasPaymentUrl) {
		return;
	}
}

onMounted(async () => {
	if (route.query.page_status === 'ok_page') {
		loadingUpdate.value = true;
		const [response] = await requestPaymentUpdate(route.query.page_status, route.query.PrivateRequestID);

		if(response.data.id) {
          details.value = response.data;
        }

        loadingUpdate.value = false;
        router.replace({ path: route.path });
		
		successModal.value = true;
		return;
	} else if(route.query.page_status === 'fail_page') {
		errorModal.value = true;
		return;
	} 

	if(details.value.collection_state) {
		showDebt.value = true;
	}
});

const debt = computed(() => details.value.debt.replace('&nbsp;', ' '));

</script>

<template>
	<Notice v-if="details.collection_state">
		<p>
			{{ __("It seems that there is") }} <strong class="red-text">{{ __("debt") }} {{ debt }} ₪</strong> {{ __("under this account. Don't worry, payment can be arranged quickly.") }}
		</p>
		<template #link>
			<a href="#" @click.prevent="handlePayment" class="link-underline">
				{{ __('to arrange the payment') }}
				<img :src="`${theme_path.url}/resources/images/svg/icon-arrow-left-bold.svg`" alt="">
			</a>
		</template>

		<DebtNoticeModal :debt="debt" @payment="handlePayment" v-if="showDebt" />
		<FraudModal class="popup--contact" :isActive="showfraudAccountPopup" @close="showfraudAccountPopup = false"></FraudModal>
		<DebtPaymentModal
			v-if="openPayment" 
			:openPayment="openPayment"
			@close="openPayment = false"
			:loadingUpdate="loadingUpdate"
			:api-payment="apiPayment"
		/>
	</Notice>
	<DebtError v-if="errorModal" @close="errorModal = false" />
	<DebtSuccess v-if="successModal" @close="successModal = false" />
</template>